module.exports = __webpack_public_path__ + "img/user-help.107abef9.svg";